import { HttpClient } from "@angular/common/http"
import { Injectable, inject } from "@angular/core"
import { Observable } from "rxjs"
import { DiscussionMasterCreateRequestDTO, DiscussionMasterDTO, DiscussionMasterUpdateRequestDTO, DiscussionMasterList, DiscussionMasterDeleteRequestDTO, DiscussionMasterReadByIdRequestDTO, DiscussionMasterReadByMasterIdRequestDTO, DiscussionMasterReadByUserIdRequestDTO, DiscussionMasterGetOrCreateOneToOneRequestDTO, GetDiscussionId, DiscussionMasterCreateGroupRequestDTO, DiscussionMasterGetDiscussionUserListRequestDTO, DiscussionUserDTO, DiscussionDTO, DiscussionList, DiscussionUserList, DiscussionListing } from "./discussion-master.interface"
import { DiscussionMaster_Create, DiscussionMaster_CreateGroup, DiscussionMaster_Delete, DiscussionMaster_GetDiscussionList, DiscussionMaster_GetDiscussionUserList, DiscussionMaster_GetOrCreateOneToOne, DiscussionMaster_ReadAll, DiscussionMaster_ReadById, DiscussionMaster_ReadByMasterId, DiscussionMaster_ReadByUserId, DiscussionMaster_Update } from "src/app/GlobalVariable"

@Injectable({
  providedIn: 'root'
})
export class DiscussionMasterService {

  constructor() { }


  http = inject(HttpClient)


  DiscussionMaster_Create(data: DiscussionMasterCreateRequestDTO): Observable<DiscussionMasterDTO> {
    return this.http.post<DiscussionMasterDTO>(DiscussionMaster_Create, data)
  }

  DiscussionMaster_Update(data: DiscussionMasterUpdateRequestDTO): Observable<DiscussionMasterDTO> {
    return this.http.post<DiscussionMasterDTO>(DiscussionMaster_Update, data)
  }

  DiscussionMaster_ReadAll(): Observable<DiscussionMasterList> {
    return this.http.get<DiscussionMasterList>(DiscussionMaster_ReadAll)
  }
  DiscussionMaster_Delete(data: DiscussionMasterDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(DiscussionMaster_Delete, data)
  }


  DiscussionMaster_ReadById(data: DiscussionMasterReadByIdRequestDTO): Observable<DiscussionMasterDTO> {
    return this.http.post<DiscussionMasterDTO>(DiscussionMaster_ReadById, data)
  }

  DiscussionMaster_ReadByMasterId(data: DiscussionMasterReadByMasterIdRequestDTO): Observable<DiscussionMasterList> {
    return this.http.post<DiscussionMasterList>(DiscussionMaster_ReadByMasterId, data)
  }

  DiscussionMaster_ReadByUserId(data: DiscussionMasterReadByUserIdRequestDTO): Observable<DiscussionList> {
    return this.http.post<DiscussionList>(DiscussionMaster_ReadByUserId, data)
  }

  DiscussionMaster_GetDiscussionList(data: DiscussionMasterReadByUserIdRequestDTO): Observable<DiscussionListing> {
    return this.http.post<DiscussionListing>(DiscussionMaster_GetDiscussionList, data)
  }

  DiscussionMaster_GetOrCreateOneToOne(data: DiscussionMasterGetOrCreateOneToOneRequestDTO): Observable<GetDiscussionId> {
    return this.http.post<GetDiscussionId>(DiscussionMaster_GetOrCreateOneToOne, data)
  }

  DiscussionMaster_CreateGroup(data: DiscussionMasterCreateGroupRequestDTO): Observable<GetDiscussionId> {
    return this.http.post<GetDiscussionId>(DiscussionMaster_CreateGroup, data)
  }
  DiscussionMaster_GetDiscussionUserList(data: DiscussionMasterGetDiscussionUserListRequestDTO): Observable<DiscussionUserList> {
    return this.http.post<DiscussionUserList>(DiscussionMaster_GetDiscussionUserList, data)
  }



}
